import { FC } from 'react'
import { Box } from '@mui/material'
import { HotelDescription } from './hotelDescription'
import { HotelAmenities } from './hotelAmenities'
import { useEphemeralStore } from '../../../state/useEphemeralStore'
import { useShallow } from 'zustand/react/shallow'

export const HotelDetailsMain: FC = () => {
    const { hotelResp } = useEphemeralStore(
        useShallow((s) => ({
            hotelResp: s.hotelResp,
        }))
    )

    if (!hotelResp) {
        return null
    }

    return (
        <Box
            display={'grid'}
            maxWidth={'90vw'}
            padding={'16px 0 0 0'}
            gap={'16px'}
        >
            <HotelDescription
                description={hotelResp.hotelInfo.descriptionStruct ?? []}
            />
            <HotelAmenities amenities={hotelResp?.hotelInfo.amenities ?? []} />
        </Box>
    )
}
